import React, { useEffect, useState } from "react";

const OfflineBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  useEffect(() => {
    if (typeof window) {
      window.addEventListener("offline", function(e) {
        setShowBanner(true);
      });

      window.addEventListener("online", function(e) {
        setShowBanner(false);
      });
    }
  }, [typeof window]);
  return (
    (showBanner && (
      <div className="offline-banner d-flex align-items-center">
        <img src="/svg/offline.svg" />
        <p>You are currently offline.</p>
      </div>
    )) || <noscript />
  );
};

export default OfflineBanner;
